<template>
	<v-modal name="error-modal" :adaptive="true" :max-width="500" width="80%" height="auto" :scrollable="true" @before-close="beforeClose">
		<layout-modal>
			<div class="body">
				<div>
					<error-image :alt="texts.title" />
				</div>
				<spacer vertical />
				<div>
					<h1>{{ texts.title }}</h1>
					<p>{{ texts.description }}</p>
				</div>
			</div>
			<template v-slot:footer>
				<split-row-all :one-line="true" reverse>
					<text-button v-if="isHard" @click.prevent="reload">
						{{ texts.restart }}
					</text-button>

					<text-button v-if="!isHard" @click.prevent="close">
						{{ texts.close }}
					</text-button>

					<!-- <text-button v-if="details" @click="showDetails = !showDetails">
						{{ texts.details }}
					</text-button> -->
				</split-row-all>

				<div v-if="details && showDetails" class="details">
					<div class="well">
						<p v-for="(v, k) in details" :key="k">
							<strong>{{ k }}:</strong>
							<br />
							{{ v }}
						</p>
					</div>
				</div>
			</template>
		</layout-modal>
	</v-modal>
</template>

<script>
import SplitRowAll from '@/components/elements/SplitRowAll'
import TextButton from '@/components/elements/TextButton'
import LayoutModal from '../layouts/LayoutModal'
import { mapGetters } from 'vuex'

export default {
	components: {
		LayoutModal,
		SplitRowAll,
		TextButton,
	},
	props: {},
	data() {
		return {
			showDetails: true,
		}
	},
	computed: {
		texts() {
			const base = this.$t('modal_error')
			const overrides = this.error.type ? this.$t('modal_error_' + this.error.type) : {} || {}
			return { ...base, ...overrides }
		},
		isHard() {
			return this.error && this.error.hard
		},
		details() {
			return this.error && this.error.details ? this.error.details : null
		},
		...mapGetters({
			error: 'error/getError',
		}),
	},
	mounted() {
		this.$modal.show('error-modal')
	},
	methods: {
		reload() {
			window.location.reload(true)
		},
		close() {
			this.$modal.hide('error-modal')
		},
		beforeClose(event) {
			if (this.isHard) {
				event.stop()
			} else {
				this.$store.commit('error/clearError')
			}
		},
	},
}
</script>

<style scoped>
.body {
	display: flex;
	justify-content: space-between;
}

.body img {
	display: block;
	margin: 0 auto;
}

.body h1 {
	font-size: 22px;
	margin-top: 0;
}

.body p {
	font-size: 14px;
}

.well {
	min-height: 20px;
	padding: 19px;
	margin-bottom: 20px;
	background-color: #f5f5f5;
	border: 1px solid #e3e3e3;
	border-radius: 4px;
	-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.details {
	margin: 0;
	margin-top: 1rem;
}

.details > div {
	margin: 0;
	word-break: break-all;
}

@media all and (max-width: 819px) {
	.body {
		flex-direction: column;
	}

	.body h1,
	.body p {
		text-align: center;
	}
}
</style>
